export default "__VITE_ASSET__Dia0UCu2__"